import { render, staticRenderFns } from "./TechRange.vue?vue&type=template&id=2c9fa700&scoped=true&"
import script from "./TechRange.vue?vue&type=script&lang=js&"
export * from "./TechRange.vue?vue&type=script&lang=js&"
import style0 from "./TechRange.vue?vue&type=style&index=0&id=2c9fa700&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9fa700",
  null
  
)

export default component.exports